module.exports = __webpack_public_path__ + "static/ssfund-cadccab961769eeac273ac3ba969c191.jpg";